(function () {
  var root = document.getElementById("tt-shipping");
  if (!root) return;

  var form = document.getElementById("tt-shipping-form");
  var result = document.getElementById("tt-shipping-result");
  var missing = document.getElementById("tt-shipping-missing");
  var failed = document.getElementById("tt-shipping-failed");
  var submit = form.querySelector("button");
  var emailInput = form.querySelector('[name="email"]');
  var numberInput = form.querySelector('[name="order_number"]');

  var steps = [
    { id: "confirmed", label: "Confirmed" },
    { id: "in_production", label: "Preparing" },
    { id: "shipped", label: "Shipped" },
    { id: "delivered", label: "Delivered" }
  ];

  var headlines = {
    confirmed: "We've received your order",
    in_production: "Your order is in production",
    shipped: "Your order is on its way!",
    delivered: "Your order has been delivered"
  };

  var infoIcon = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M10 9v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="10" cy="6.4" r="0.9" fill="currentColor"/></svg>';
  var copyIcon = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M10.5 5.5V3.8A1.3 1.3 0 0 0 9.2 2.5H3.8A1.3 1.3 0 0 0 2.5 3.8v5.4A1.3 1.3 0 0 0 3.8 10.5H5.5" stroke="currentColor" stroke-width="1.4"/></svg>';
  var arrowIcon = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var placeholderIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><circle cx="9" cy="10" r="1.4" fill="currentColor"/><path d="M5.5 16.5 9.5 13l3 2.5 2.2-2 3.8 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var previewOverlay = null;
  var previewLastFocus = null;

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    hide(missing);
    hide(failed);

    var email = emailInput.value.trim();
    var orderNumber = numberInput.value.trim();
    if (!email || !orderNumber) {
      show(missing);
      return;
    }

    submit.disabled = true;
    submit.textContent = "Looking up your order";

    fetch("https://app.agentallen.ai/api/orders/tracking", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: email,
        order_number: orderNumber
      })
    }).then(function (response) {
      if (response.status === 404) {
        show(missing);
        return null;
      }
      if (!response.ok) {
        show(failed);
        return null;
      }
      return response.json();
    }).then(function (data) {
      if (!data) return;
      renderResult(data);
    }).catch(function () {
      show(failed);
    }).then(function () {
      submit.disabled = false;
      submit.textContent = "Track my order";
    });
  });

  function renderResult(data) {
    hide(form);
    result.replaceChildren();

    var step = (data.progress && data.progress.step) || "confirmed";
    var number = (data.order && data.order.number) || "";

    var orderLine = el("p", "tt-shipping-order");
    orderLine.textContent = "Details for Order #" + number;
    result.appendChild(orderLine);

    var status = el("p", "tt-shipping-status");
    status.textContent = headlines[step] || headlines.confirmed;
    result.appendChild(status);

    result.appendChild(renderSteps(step));

    var estimate = estimateCopy(data.shipping_estimate);
    if (estimate) {
      result.appendChild(renderEstimate(estimate));
    }

    (data.shipments || []).forEach(function (shipment) {
      var block = renderShipment(shipment);
      if (block) result.appendChild(block);
    });

    var designs = data.designs || [];
    if (designs.length) {
      result.appendChild(renderItems(designs));
    }

    var again = el("button", "tt-shipping-button-alt");
    again.type = "button";
    again.textContent = "Track another order";
    again.addEventListener("click", reset);
    result.appendChild(again);

    show(result);
  }

  function renderSteps(current) {
    var list = el("ol", "tt-shipping-steps");
    var currentIndex = 0;
    steps.forEach(function (step, index) {
      if (step.id === current) currentIndex = index;
    });
    steps.forEach(function (step, index) {
      var item = el("li");
      if (index < currentIndex) item.className = "is-complete";
      if (index === currentIndex) item.className = "is-current";
      item.textContent = step.label;
      list.appendChild(item);
    });
    return list;
  }

  function metaRow(labelText, valueText) {
    var row = el("div", "tt-shipping-meta");
    var label = el("span", "tt-shipping-meta-label");
    label.textContent = labelText;
    var value = el("span", "tt-shipping-meta-value");
    value.textContent = valueText;
    row.appendChild(label);
    row.appendChild(value);
    return row;
  }

  function renderEstimate(text) {
    var note = el("div", "tt-shipping-estimate");
    note.insertAdjacentHTML("beforeend", infoIcon);
    var span = document.createElement("span");
    span.textContent = text;
    note.appendChild(span);
    return note;
  }

  function renderShipment(shipment) {
    var carrier = shipment.carrier_name || shipment.service_name || "";
    var events = shipment.events || [];
    if (!carrier && !shipment.tracking_number && !events.length && !shipment.tracking_url) {
      return null;
    }

    var block = el("div", "tt-shipping-panel");
    var head = el("div", "tt-shipping-panel-head");
    var title = el("h3");
    title.textContent = "Shipping Details";
    head.appendChild(title);
    block.appendChild(head);

    if (carrier) {
      block.appendChild(metaRow("Delivery service", carrier));
    }

    if (shipment.tracking_number) {
      var track = el("div", "tt-shipping-track");
      var copy = el("div", "tt-shipping-track-copy");
      var trackLabel = el("span", "tt-shipping-track-label");
      trackLabel.textContent = "Tracking number";
      var trackValue = el("span", "tt-shipping-track-value");
      trackValue.textContent = shipment.tracking_number;
      copy.appendChild(trackLabel);
      copy.appendChild(trackValue);
      track.appendChild(copy);
      track.appendChild(copyButton(shipment.tracking_number));
      block.appendChild(track);
    }

    if (events.length) {
      var history = el("h3", "tt-shipping-history-title");
      history.textContent = "Tracking History";
      block.appendChild(history);

      var list = el("ol", "tt-shipping-events");
      events.forEach(function (event) {
        var item = el("li");
        var description = el("span", "tt-shipping-event-desc");
        description.textContent = event.description || "Update";
        item.appendChild(description);
        if (event.location) {
          var location = el("span", "tt-shipping-event-loc");
          location.textContent = event.location;
          item.appendChild(location);
        }
        var when = document.createElement("time");
        when.dateTime = event.occurred_at || "";
        when.textContent = formatWhen(event.occurred_at);
        item.appendChild(when);
        list.appendChild(item);
      });
      block.appendChild(list);
    }

    if (shipment.tracking_url) {
      var link = el("a", "tt-shipping-track-link");
      link.href = shipment.tracking_url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      var linkText = document.createElement("span");
      linkText.textContent = "View tracking information";
      link.appendChild(linkText);
      link.insertAdjacentHTML("beforeend", arrowIcon);
      block.appendChild(link);
    }

    return block;
  }

  function renderItems(designs) {
    var block = el("div", "tt-shipping-panel");
    var head = el("div", "tt-shipping-panel-head");
    var title = el("h3");
    title.textContent = "Items in Your Order";
    var count = el("span", "tt-shipping-panel-count");
    count.textContent = designs.length + (designs.length === 1 ? " item" : " items");
    head.appendChild(title);
    head.appendChild(count);
    block.appendChild(head);

    designs.forEach(function (design) {
      block.appendChild(renderDesign(design));
    });
    return block;
  }

  function renderDesign(design) {
    var block = el("div", "tt-shipping-design");
    if (design.preview_url) {
      var preview = el("button", "tt-shipping-design-preview");
      preview.type = "button";
      preview.setAttribute("aria-label", "View larger preview of " + (design.title || "item"));
      var image = document.createElement("img");
      image.src = design.preview_url;
      image.alt = design.title || "Item";
      preview.appendChild(image);
      preview.addEventListener("click", function () {
        openDesignPreview(design.preview_url, design.title || "Item", preview);
      });
      block.appendChild(preview);
    } else {
      var placeholder = el("span", "tt-shipping-design-placeholder");
      placeholder.innerHTML = placeholderIcon;
      block.appendChild(placeholder);
    }
    var copy = el("div");
    var title = el("p", "tt-shipping-design-title");
    title.textContent = design.title || "Item";
    copy.appendChild(title);
    if (design.variant_title) {
      var meta = el("p", "tt-shipping-design-meta");
      meta.textContent = design.variant_title;
      copy.appendChild(meta);
    }
    block.appendChild(copy);
    return block;
  }

  function copyButton(value) {
    var button = el("button", "tt-shipping-copy");
    button.type = "button";
    button.insertAdjacentHTML("beforeend", copyIcon);
    var label = document.createElement("span");
    label.textContent = "Copy";
    button.appendChild(label);
    button.addEventListener("click", function () {
      var done = function () {
        label.textContent = "Copied";
        window.setTimeout(function () {
          label.textContent = "Copy";
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(done).catch(function () {
          fallbackCopy(value);
          done();
        });
      } else {
        fallbackCopy(value);
        done();
      }
    });
    return button;
  }

  function fallbackCopy(value) {
    var field = document.createElement("textarea");
    field.value = value;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.left = "-9999px";
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand("copy");
    } catch (error) {
      return;
    }
    document.body.removeChild(field);
  }

  function estimateCopy(estimate) {
    if (!estimate) return "";
    if (estimate.status === "paused") {
      return "Production is paused on this order. We'll start the usual timeframe once it resumes.";
    }
    if (estimate.status === "overdue") {
      return "This order is taking longer than similar orders usually do. The tracking updates below are the latest we have.";
    }

    var parts = [];
    if (estimate.remaining) {
      parts.push("Similar orders usually have " + range(estimate.remaining) + " left.");
    } else if (estimate.typical) {
      parts.push("Similar orders usually take " + range(estimate.typical) + ".");
    }
    if (estimate.production && estimate.transit) {
      parts.push("About " + range(estimate.production) + " of that is production, and " + range(estimate.transit) + " is transit.");
    } else if (estimate.production_outlook === "likely_today_or_few_hours") {
      parts.push("Production usually finishes today or within a few hours.");
    } else if (estimate.production_outlook === "likely_within_one_business_day") {
      parts.push("Production usually finishes within one business day.");
    }
    if (!parts.length) return "";
    parts.push("This is a typical range, not a delivery promise.");
    return parts.join(" ");
  }

  function range(value) {
    var low = Number(value.low);
    var high = Number(value.high);
    if (low === high) return low + " business day" + (low === 1 ? "" : "s");
    return low + "–" + high + " business days";
  }

  function formatWhen(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var minutes = date.getMinutes();
    var minuteText = minutes < 10 ? "0" + minutes : String(minutes);
    return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + ", " + date.getHours() + ":" + minuteText;
  }

  function openDesignPreview(url, alt, trigger) {
    closeDesignPreview();
    previewLastFocus = trigger || document.activeElement;

    var overlay = el("div", "tt-shipping-preview");
    var dialog = el("div", "tt-shipping-preview-dialog");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-label", alt || "Design preview");

    var close = el("button", "tt-shipping-preview-close");
    close.type = "button";
    close.setAttribute("aria-label", "Close preview");
    close.textContent = "\u00d7";

    var image = document.createElement("img");
    image.className = "tt-shipping-preview-image";
    image.src = url;
    image.alt = alt || "Design preview";

    dialog.appendChild(close);
    dialog.appendChild(image);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    previewOverlay = overlay;
    document.body.classList.add("tt-shipping-preview-open");

    close.addEventListener("click", function (event) {
      event.stopPropagation();
      closeDesignPreview();
    });
    dialog.addEventListener("click", function (event) {
      event.stopPropagation();
    });
    overlay.addEventListener("click", closeDesignPreview);
    close.focus();
  }

  function closeDesignPreview() {
    if (!previewOverlay) return;
    previewOverlay.remove();
    previewOverlay = null;
    document.body.classList.remove("tt-shipping-preview-open");
    if (previewLastFocus && typeof previewLastFocus.focus === "function") {
      previewLastFocus.focus();
    }
    previewLastFocus = null;
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDesignPreview();
  });

  function reset() {
    closeDesignPreview();
    numberInput.value = "";
    result.replaceChildren();
    hide(result);
    hide(missing);
    hide(failed);
    show(form);
    numberInput.focus();
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function show(node) {
    node.hidden = false;
  }

  function hide(node) {
    node.hidden = true;
  }

  var quote = document.getElementById("tt-shipping-quote");
  var quoteForm = document.getElementById("tt-shipping-quote-form");
  if (quote && quoteForm) {
    var quoteResult = document.getElementById("tt-shipping-quote-result");
    var quoteEmpty = document.getElementById("tt-shipping-quote-empty");
    var quoteMissing = document.getElementById("tt-shipping-quote-missing");
    var quoteFailed = document.getElementById("tt-shipping-quote-failed");
    var quoteSubmit = quoteForm.querySelector("button");
    var locationInput = quoteForm.querySelector('[name="location"]');
    var placeSearch = quoteForm.querySelector(".tt-shipping-quote-search");
    var placeSuggestions = document.getElementById("tt-shipping-quote-suggestions");
    var placeSuggestionList = document.getElementById("tt-shipping-quote-suggestion-list");
    var placesApiKey = "AIzaSyAWDWKKLS8hnej_FOBMEExVF2frP3jWsSY";
    var placesSessionToken = null;
    var placesSessionLastAt = 0;
    var placesDebounceTimer = null;
    var placesRequestAt = 0;
    var placesSelectSeq = 0;
    var selectedPlace = null;
    var selectedPlacePromise = null;
    var visitorLocationPromise = null;
    visitorLocation();
    var quoteMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var quoteServices = [
      { id: "standard", label: "Standard Shipping", icon: quote.getAttribute("data-standard-icon") },
      { id: "express", label: "Express Shipping", icon: quote.getAttribute("data-express-icon") }
    ];

    locationInput.addEventListener("input", schedulePlaceSearch);
    locationInput.addEventListener("keyup", schedulePlaceSearch);
    locationInput.addEventListener("compositionend", schedulePlaceSearch);
    locationInput.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      event.preventDefault();
      clearPlaceSearchTimer();
      hidePlaceSuggestions();
    });
    document.addEventListener("click", function (event) {
      if (!placeSearch || placeSearch.contains(event.target)) return;
      hidePlaceSuggestions();
    });

    quoteForm.addEventListener("submit", function (event) {
      event.preventDefault();
      hidePlaceSuggestions();
      hide(quoteEmpty);
      hide(quoteMissing);
      hide(quoteFailed);

      var pendingPlace = selectedPlacePromise;
      if (pendingPlace) {
        quoteSubmit.disabled = true;
        quoteSubmit.textContent = "Getting estimate";
        pendingPlace.then(requestEstimate);
        return;
      }

      requestEstimate();
    });

    function requestEstimate() {
      var body = estimateRequestBody();
      if (!body) {
        hide(quoteResult);
        quoteResult.replaceChildren();
        show(quoteEmpty);
        quoteSubmit.disabled = false;
        quoteSubmit.textContent = "Get Estimate";
        return;
      }

      quoteSubmit.disabled = true;
      quoteSubmit.textContent = "Getting estimate";

      fetch("https://app.agentallen.ai/api/shipping/estimate", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (response.status === 404) {
          show(quoteMissing);
          return null;
        }
        if (!response.ok) {
          show(quoteFailed);
          return null;
        }
        return response.json();
      }).then(function (data) {
        if (!data) {
          hide(quoteResult);
          quoteResult.replaceChildren();
          return;
        }
        if (!renderQuote(data)) show(quoteFailed);
      }).catch(function () {
        hide(quoteResult);
        quoteResult.replaceChildren();
        show(quoteFailed);
      }).then(function () {
        quoteSubmit.disabled = false;
        quoteSubmit.textContent = "Get Estimate";
      });
    }

    function renderQuote(data) {
      var byService = {};
      (data.options || []).forEach(function (option) {
        if (option && option.service) byService[option.service] = option;
      });

      var cards = [];
      quoteServices.forEach(function (service) {
        var card = renderQuoteOption(service, byService[service.id]);
        if (card) cards.push(card);
      });
      if (!cards.length) {
        hide(quoteResult);
        quoteResult.replaceChildren();
        return false;
      }

      quoteResult.replaceChildren();
      var label = el("p", "tt-shipping-quote-label");
      label.textContent = "Estimated arrival if you order today";
      quoteResult.appendChild(label);

      var options = el("div", "tt-shipping-quote-options");
      cards.forEach(function (card) {
        options.appendChild(card);
      });
      quoteResult.appendChild(options);

      var note = el("p", "tt-shipping-quote-note");
      note.insertAdjacentHTML("beforeend", infoIcon);
      var noteText = document.createElement("span");
      noteText.textContent = "Includes production time. Estimates are not guaranteed. | Powered by Agent Allen.";
      note.appendChild(noteText);
      quoteResult.appendChild(note);

      show(quoteResult);
      return true;
    }

    function renderQuoteOption(service, option) {
      if (!option || !option.business_days || !option.arrives) return null;
      var dates = formatArrival(option.arrives.from, option.arrives.to);
      var days = formatBusinessDays(option.business_days);
      if (!dates || !days) return null;

      var card = el("div", "tt-shipping-quote-option");
      if (service.icon) {
        var image = document.createElement("img");
        image.src = service.icon;
        image.alt = "";
        image.width = 40;
        image.height = 40;
        card.appendChild(image);
      }
      var copy = el("div", "tt-shipping-quote-copy");
      var dateLine = el("p", "tt-shipping-quote-dates");
      dateLine.textContent = dates;
      var nameLine = el("p", "tt-shipping-quote-service");
      nameLine.textContent = service.label;
      var dayLine = el("p", "tt-shipping-quote-days");
      dayLine.textContent = days;
      copy.appendChild(dateLine);
      copy.appendChild(nameLine);
      copy.appendChild(dayLine);
      card.appendChild(copy);
      return card;
    }

    function formatArrival(from, to) {
      var start = parseQuoteDate(from);
      var end = parseQuoteDate(to);
      if (!start || !end) return "";
      if (start.getTime() === end.getTime()) {
        return start.getDate() + " " + quoteMonths[start.getMonth()];
      }
      if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
        return start.getDate() + " – " + end.getDate() + " " + quoteMonths[start.getMonth()];
      }
      return start.getDate() + " " + quoteMonths[start.getMonth()] + " – " + end.getDate() + " " + quoteMonths[end.getMonth()];
    }

    function formatBusinessDays(value) {
      var low = Number(value.low);
      var high = Number(value.high);
      if (!isFinite(low) || !isFinite(high) || low < 0 || high < low) return "";
      low = Math.round(low);
      high = Math.round(high);
      if (low === high) return low + " Business Day" + (low === 1 ? "" : "s");
      return low + "–" + high + " Business Days";
    }

    function schedulePlaceSearch(event) {
      if (event && (event.key === "Enter" || event.keyCode === 13)) return;
      selectedPlace = null;
      selectedPlacePromise = null;
      placesSelectSeq += 1;
      clearPlaceSearchTimer();
      placesDebounceTimer = setTimeout(function () {
        placesDebounceTimer = null;
        loadPlaceSuggestions();
      }, 350);
    }

    function clearPlaceSearchTimer() {
      if (placesDebounceTimer == null) return;
      clearTimeout(placesDebounceTimer);
      placesDebounceTimer = null;
    }

    function resetPlaceSession() {
      placesSessionToken = null;
      placesSessionLastAt = 0;
    }

    function hidePlaceSuggestions() {
      if (!placeSuggestionList || !placeSuggestions) return;
      placeSuggestionList.replaceChildren();
      hide(placeSuggestions);
    }

    function loadPlaceSuggestions() {
      var requestAt = Date.now();
      placesRequestAt = requestAt;
      var query = locationInput.value.trim();
      if (query.length < 3) {
        hidePlaceSuggestions();
        resetPlaceSession();
        return;
      }

      if (
        placesSessionToken &&
        placesSessionLastAt > 0 &&
        requestAt - placesSessionLastAt > 180000
      ) {
        resetPlaceSession();
      }

      searchPlaces(query).then(function (suggestions) {
        if (requestAt !== placesRequestAt) return;
        if (locationInput.value.trim().length < 3) return;
        renderPlaceSuggestions(suggestions, query);
      }).catch(function () {
        if (requestAt !== placesRequestAt) return;
        hidePlaceSuggestions();
      });
    }

    function searchPlaces(query) {
      if (!placesSessionToken) placesSessionToken = makePlaceSessionToken();
      var sessionToken = placesSessionToken;
      placesSessionLastAt = Date.now();

      return visitorLocation().then(function (loc) {
        var body = {
          input: query,
          languageCode: "en",
          sessionToken: sessionToken
        };
        if (loc) {
          body.locationBias = {
            circle: {
              center: { latitude: loc.latitude, longitude: loc.longitude },
              radius: 50000.0
            }
          };
        }
        return fetch("https://places.googleapis.com/v1/places:autocomplete", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": placesApiKey,
            "X-Goog-FieldMask": "suggestions.placePrediction.placeId,suggestions.placePrediction.text,suggestions.placePrediction.structuredFormat"
          },
          body: JSON.stringify(body)
        });
      }).then(function (response) {
        if (!response.ok) return [];
        return response.json();
      }).then(function (data) {
        var suggestions = [];
        var rows = (data && data.suggestions) || [];
        rows.forEach(function (row) {
          var prediction = row && row.placePrediction;
          if (!prediction || !prediction.placeId) return;
          var label = (prediction.text && prediction.text.text) || "";
          var mainText = prediction.structuredFormat &&
            prediction.structuredFormat.mainText &&
            prediction.structuredFormat.mainText.text;
          var title = mainText || (label.split(",")[0] || "").trim() || label || prediction.placeId;
          suggestions.push({
            google_place_id: prediction.placeId,
            title: title,
            address: { label: label || title }
          });
        });
        return suggestions;
      });
    }

    function renderPlaceSuggestions(suggestions, query) {
      if (!suggestions.length) {
        hidePlaceSuggestions();
        return;
      }

      placeSuggestionList.replaceChildren();
      suggestions.forEach(function (suggestion) {
        var row = el("div", "mapbox-location-search-mapbox-suggestions-item");
        var text = document.createElement("p");
        text.innerHTML = boldPlaceSuggestion(suggestion.title, suggestion.address.label, query);
        row.appendChild(text);
        row.addEventListener("mousedown", function (event) {
          event.preventDefault();
        });
        row.addEventListener("click", function () {
          selectPlaceSuggestion(suggestion);
        });
        placeSuggestionList.appendChild(row);
      });
      show(placeSuggestions);
    }

    function selectPlaceSuggestion(suggestion) {
      var seq = ++placesSelectSeq;
      placesRequestAt = Date.now();
      clearPlaceSearchTimer();
      hidePlaceSuggestions();
      var fallback = (suggestion.address && suggestion.address.label) || suggestion.title || "";
      locationInput.value = fallback;
      selectedPlace = null;
      selectedPlacePromise = fetchPlaceAddress(suggestion.google_place_id).then(function (place) {
        if (seq !== placesSelectSeq || !place) return;
        selectedPlace = placeEstimateParts(place);
        locationInput.value = placeDisplayLabel(selectedPlace) || place.formattedAddress || place.shortFormattedAddress || locationInput.value;
      });
    }

    function estimateRequestBody() {
      if (selectedPlace) {
        var picked = {};
        var postcode = selectedPlace.location;
        var city = selectedPlace.city;
        if (postcode) picked.location = postcode;
        else if (city) picked.location = city;
        if (city) picked.city = city;
        if (selectedPlace.state) picked.state = selectedPlace.state;
        if (selectedPlace.country) picked.country = selectedPlace.country;
        if (picked.location || picked.city) return picked;
      }

      var typed = locationInput.value.trim();
      if (!typed || typed.indexOf(",") !== -1) return null;
      return { location: typed };
    }

    function readVisitorLocation() {
      var stored = null;
      if (typeof $cookies !== "undefined" && $cookies && typeof $cookies.get === "function") {
        stored = $cookies.get("444-loc");
      }
      if (!stored) {
        var match = document.cookie.match(/(?:^|; )444-loc=([^;]*)/);
        if (match) {
          try {
            stored = JSON.parse(decodeURIComponent(match[1]));
          } catch (error) {
            stored = null;
          }
        }
      }
      if (typeof stored === "string") {
        try {
          stored = JSON.parse(stored);
        } catch (error) {
          stored = null;
        }
      }
      if (!stored) return null;
      var latitude = Number(stored.latitude);
      var longitude = Number(stored.longitude);
      if (!isFinite(latitude) || !isFinite(longitude)) return null;
      return { latitude: latitude, longitude: longitude };
    }

    function visitorLocation() {
      var cached = readVisitorLocation();
      if (cached) return Promise.resolve(cached);
      if (!visitorLocationPromise) {
        visitorLocationPromise = fetch("https://api.ipdata.co?api-key=6b9a8ae2c2b332473826112821c538610e16d221675cf5d9be635e98")
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .then(function (data) {
            if (!data || data.latitude == null || data.longitude == null) return null;
            var loc = { latitude: Number(data.latitude), longitude: Number(data.longitude) };
            if (!isFinite(loc.latitude) || !isFinite(loc.longitude)) return null;
            if (!readVisitorLocation()) {
              if (typeof $cookies !== "undefined" && $cookies && typeof $cookies.set === "function") {
                $cookies.set("444-loc", loc, Infinity, "/");
              } else {
                document.cookie = "444-loc=" + encodeURIComponent(JSON.stringify(loc)) + "; path=/";
              }
            }
            return loc;
          })
          .catch(function () {
            return null;
          });
      }
      return visitorLocationPromise;
    }

    function placeDisplayLabel(parts) {
      if (!parts) return "";
      var place = [];
      if (parts.city) place.push(parts.city);
      if (parts.state) place.push(parts.state);
      var label = place.join(" ");
      if (parts.location) label = label ? label + " " + parts.location : parts.location;
      return label;
    }

    function placeEstimateParts(place) {
      var postcode = placeComponent(place, "postal_code", false).replace(/\s+/g, "");
      var city = placeComponent(place, "locality", false) || placeComponent(place, "postal_town", false);
      var state = placeComponent(place, "administrative_area_level_1", true);
      var country = placeComponent(place, "country", true);
      return {
        location: postcode,
        city: city,
        state: state,
        country: country
      };
    }

    function fetchPlaceAddress(placeId) {
      var sessionSnapshot = placesSessionToken;
      if (!placeId || !sessionSnapshot) return Promise.resolve(null);
      var detailUrl = "https://places.googleapis.com/v1/places/" +
        encodeURIComponent(placeId) +
        "?sessionToken=" +
        encodeURIComponent(sessionSnapshot);

      return fetch(detailUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": placesApiKey,
          "X-Goog-FieldMask": "id,formattedAddress,location,addressComponents,types,shortFormattedAddress"
        }
      }).then(function (response) {
        if (!response.ok) return null;
        return response.json();
      }).then(function (place) {
        var address = (place && (place.formattedAddress || place.shortFormattedAddress)) || "";
        if (address && placesSessionToken === sessionSnapshot) resetPlaceSession();
        return address ? place : null;
      }).catch(function () {
        return null;
      });
    }

    function placeComponent(place, type, shortName) {
      var components = (place && place.addressComponents) || [];
      for (var i = 0; i < components.length; i++) {
        var types = components[i].types || [];
        if (types.indexOf(type) === -1) continue;
        if (shortName) return components[i].shortText || components[i].short_name || "";
        return components[i].longText || components[i].long_name || components[i].shortText || components[i].short_name || "";
      }
      return "";
    }

    function boldPlaceSuggestion(title, label, search) {
      var words = String(search || "").toLowerCase().split(" ");
      var typed = words.map(function (word) {
        return word.charAt(0).toUpperCase() + word.substring(1);
      }).join(" ");
      var html;
      if (title !== label) {
        var prefix = title + ", ";
        var rest = label.indexOf(prefix) === 0 ? label.slice(prefix.length) : label;
        html = escapePlaceText(title) + ", <span style=\"font-size:10px;\">" + escapePlaceText(rest) + "</span>";
      } else {
        html = escapePlaceText(label);
      }
      var needle = escapePlaceText(typed);
      if (!needle) return html;
      return html.replace(needle, "<strong>" + needle + "</strong>");
    }

    function escapePlaceText(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function makePlaceSessionToken() {
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }

    function parseQuoteDate(value) {
      var parts = String(value || "").split("-");
      if (parts.length !== 3) return null;
      var year = Number(parts[0]);
      var month = Number(parts[1]);
      var day = Number(parts[2]);
      if (!year || month < 1 || month > 12 || day < 1 || day > 31) return null;
      var date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
      return date;
    }
  }
})();
